<template>
  <div id="app">
    <main class="c-main" role="main">
      <div class="o-wrapper">
        <nav class="c-breadcrumb u-hidden--um" aria-label="Vous êtes ici">
          <ul class="c-breadcrumb__list">
            <li class="c-breadcrumb__item">
              <a href="/">{{ Params.lang === "fr" ? "Accueil" : "Home" }}</a>
            </li>
            <li class="c-breadcrumb__item">
              <a href="#" @click="back">Stock</a>
            </li>
            <li class="c-breadcrumb__item">{{ Params.lang === "fr" ? "Fiche produit" : "Product" }}</li>
          </ul>
        </nav>
        <h1 class="c-h1">
          <span>{{ Params.lang === "fr" ? "Fiche produit" : "Product" }}</span>
          <button
            class="c-favorite"
            :title="Params.lang === 'fr' ? 'Imprimer la fiche' : 'Print product'"
            @click="printProduit"
          >
            <img
              width="24px"
              height="24px"
              src="img/printer.svg"
              :alt="Params.lang === 'fr' ? 'Imprimer la fiche' : 'Print product'"
            />
          </button>
        </h1>

        <!-- fiche produit -->
        <div v-for="lot in Datas" :key="lot.loref" class="print-margin c-result c-result--favorite">
          <!-- entete produit -->
          <h3 class="c-h4 c-result__title">
            <a :href="lienRetourStock(lot)">
              <div class="c-result__button">
                {{
                  Params.lang === "fr"
                    ? lot.texte.substring(0, lot.texte.indexOf("\r"))
                    : lot.texte_en.substring(0, lot.texte.indexOf("\r"))
                }}
              </div>
            </a>
          </h3>

          <!-- wrapper produit -->
          <div class="c-result__wrapper">
            <!-- fiche lot -->
            <div class="c-result__container">
              <!-- entete lot -->
              <div class="lot-title">
                <h4 class="c-h5 c-result__subtitle">{{ Params.lang === "fr" ? lot.lo_texte : lot.lo_texte_en }}</h4>

                <h4 v-if="lot.lo_prix > 0" class="c-h5">
                  {{ lot.lo_prix }}&nbsp;&euro;&nbsp;HT&nbsp;/&nbsp;{{ lot.lo_unite }}
                </h4>
                <div>
                  <a class="c-favorite lot-icons" title="Zoom photo" @click="zoomPhoto(lot)">
                    <img width="18px" height="18px" src="img/zoom.svg" alt="Zoom photo" />
                  </a>
                  <a
                    class="c-favorite lot-icons"
                    :title="Params.lang === 'fr' ? 'Favori' : 'Bookmark'"
                    @click="toggleFavori(lot.loref)"
                  >
                    <img :alt="lot.loref" :ref="lot.loref" class="lot-title-img animated" :src="favoriSrc(lot.loref)" />
                  </a>
                </div>
              </div>
              <!-- fin lot-title -->

              <!-- image -->
              <a class="c-result__link" tabindex="-1" :href="'#' + lot.loref">
                <img
                  loading="eager"
                  class="c-result__img"
                  width="300"
                  :src="ServerName + lot.lo_url.replace('.jpg', '-vignette.jpg')"
                  :alt="Params.lang === 'fr' ? lot.lo_texte : lot.lo_texte_en"
                />
              </a>

              <!-- image hd overlay -->
              <a :id="lot.loref" tabindex="-1" href="#_" class="c-overlay">
                <div class="overlay-flex">
                  <img
                    class="c-overlay__img"
                    loading="lazy"
                    :src="ServerName + lot.lo_url"
                    :alt="Params.lang === 'fr' ? lot.lo_texte : lot.lo_texte_en"
                  />
                  <div v-if="!lot.lo_url.includes(lot.loref)" class="overlay-text">
                    {{
                      Params.lang === "fr"
                        ? "Image de substitution, la photo du lot n'est pas disponible sur le site"
                        : "Replacement image, the product's photo is not available on the site"
                    }}
                  </div>
                </div>
              </a>
              <!-- fin image hd overlay-->
              <!-- fin image -->

              <!-- dimensions lot -->
              <table>
                <tr>
                  <th>
                    Dimensions
                    <span class="u-hidden--um">{{ Params.lang === "fr" ? "en " : "in " }}cm</span>
                    <span class="u-hidden--fm">(cm)</span>
                  </th>
                  <th>
                    <span class="u-hidden--um">{{ Params.lang === "fr" ? "Etat du " : "Current " }}</span
                    >stock
                  </th>
                </tr>
                <tr>
                  <td>{{ Params.lang === "fr" ? "Longueur" : "length" }} : {{ lot.lo_long }}</td>
                  <td>
                    <span class="u-hidden--um">{{ Params.lang === "fr" ? "Quantité " : "Quantity " }}</span>
                    {{ Params.lang === "fr" ? "disponible" : "available" }} : {{ lot.lo_dispo }} -
                    {{ lot.lo_dispo_m2 }}
                    <abbr>
                      m
                      <sup>2</sup>
                    </abbr>
                  </td>
                </tr>

                <tr>
                  <td>{{ Params.lang === "fr" ? "Largeur" : "width" }} : {{ lot.lo_larg }}</td>
                  <td>
                    <span class="u-hidden--um">{{ Params.lang === "fr" ? "Quantité " : "Quantity " }}</span>
                    {{ Params.lang === "fr" ? "réservé" : "reserved" }} : {{ lot.lo_resa }} -
                    {{ lot.lo_resa_m2 }}
                    <abbr>
                      m
                      <sup>2</sup>
                    </abbr>
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ Params.lang === "fr" ? "Épaisseur" : "Thickness" }} :
                    {{ lot.lo_epaisseur.replace("cm", "") }}
                  </td>
                  <td>
                    <!-- ne plus faire BDS 2020-07-19 <span
                      class="u-hidden--um"
                    >{{ Params.lang === "fr" ? "Mise à jour : " : "Date : " }}</span>
                    <span>{{ setDateMaj( lot.lo_arrivee ) }}</span>
                    -->
                    <span v-if="!lot.lo_url.includes(lot.loref)">
                      {{ Params.lang === "fr" ? "Image de substitution" : "Replacement image" }}
                    </span>
                  </td>
                </tr>
              </table>

              <!-- fin dimensions lot -->
            </div>
            <!-- fin fiche lot -->
          </div>
          <!-- fin wrapper produit -->
        </div>
        <!-- fin liste -->
      </div>
      <!-- fin wrapper -->
    </main>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<style>
@media print {
  header,
  header *,
  nav,
  nav *,
  footer,
  footer * {
    display: none !important;
  }
  h1 {
    margin-top: 0 !important;
  }
  .print-margin:nth-child(even) {
    page-break-after: always;
  }
}
.overlay-flex {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.overlay-text,
.overlay-text:hover {
  color: lightgray;
  font-weight: 200;
  font-size: 1.1em;
}
.c-overlay:hover {
  text-decoration: none;
  outline: unset;
}
.lot-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.lot-title-img {
  width: 26px;
  height: 26px;
}
.lot-icons {
  margin-left: 12px;
}
.c-h1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.c-h5 {
  margin-top: 6px;
  margin-bottom: 6px;
  font-size: 1.2em;
  line-height: inherit;
}
.c-result__subtitle {
  border-top: none;
}
</style>

<script>
export default {
  name: "App",
  data() {
    return {
      // eslint-disable-next-line no-undef
      ServerName: process.env.NODE_ENV === "production" ? "" : "https://www.spadaccini.fr",
      Datas: [],
      Favoris: []
    };
  },
  computed: {
    Params() {
      return this.$bd.getUrlParams({
        lang: window.location.hostname.includes(".com") ? "en" : "fr",
        cle: "",
        loref: ""
      });
    }
  },
  created() {
    this.getFavoris();
    this.getDatas();
  },
  methods: {
    setQuery() {
      let query = "";
      for (const key in this.Params) {
        if (this.Params[key]) {
          query = query + "&" + key + "=" + this.Params[key];
        }
      }
      return query.substring(1);
    },
    getDatas() {
      const query = this.setQuery();
      if (query.length === 0) return;
      this.$Progress.start();
      this.$axios
        .get("/icat/api/fiche-produit?" + this.setQuery())
        .then(response => {
          if (response.data.messagetype !== "success") {
            this.$toasted.info(response.data.message);
          } else {
            this.Datas = response.data.Datas;
            const title = this.Datas[0].nom;
            if (title) document.title = title + " | Spadaccini";
          }
        })
        .catch(e => {
          this.$toasted.info("Erreur réseau. Veuillez recommencer ultérieurement");
          window.thinlogger("axios " + e + " response " + JSON.stringify(e.response));
        })

        .finally(() => {
          this.$Progress.finish();
        });
    },
    lienRetourStock(lot) {
      const selection = lot.format === "tranche" ? "tranches" : "pdm";
      return "liste.html?selection=" + selection + "&filtre=" + lot.nom;
    },
    printProduit() {
      window.print();
    },
    zoomPhoto(lot) {
      // src=/Lot/G_DC63.jpg&titre=Tranche granit AMAZONE BLEU&sstitre=Lot DC63 bleu poli
      let titre = this.Params.lang === "fr" ? lot.texte : lot.texte_en;
      titre = titre.substring(0, titre.indexOf("\r"));
      const sstitre = this.Params.lang === "fr" ? lot.lo_texte : lot.lo_texte_en;
      window.location =
        "photo-lot.html?src=" + this.ServerName + lot.lo_url + "&titre=" + titre + "&sstitre=" + sstitre;
    },
    setDateMaj(lodatar) {
      // nettoyage des dates trop anciennes
      const ThisYear = new Date().getFullYear();
      let annee = lodatar.substring(6);
      if (annee < ThisYear - 1) {
        annee = ThisYear - 1;
      }
      return annee + "-" + lodatar.substring(3, 5);
    },
    getFavoris() {
      let s = this.$cookie.getItem("Favoris");
      if (!s || s == "undefined") return;
      this.Favoris = s.split(",");
    },
    favoriSrc(loref) {
      if (this.Favoris.includes(loref)) {
        return "img/sprite.svg#favorite--active";
      } else {
        return "img/sprite.svg#favorite";
      }
    },
    toggleFavori(loref) {
      // animate it voir https://daneden.github.io/animate.css/
      let animation = "bounce";
      const ref = this.$refs[loref][0];

      const favindex = this.Favoris.findIndex(item => item === loref);
      if (favindex >= 0) {
        this.Favoris.splice(favindex, 1); // remove it
        animation = "rotateIn";
      } else {
        this.Favoris.push(loref); // add it
        animation = "rotateOut";
      }
      ref.classList.add(animation);
      this.$cookie.setItem("Favoris", this.Favoris.join(","), Infinity);
      setTimeout(() => ref.classList.remove(animation), 1000);
    },
    back() {
      if (document.referrer.includes("liste.html")) {
        history.back();
      } else {
        window.location.href = "liste.html";
      }
    }
  }
};
</script>
